import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import * as func from "../../../common/manipurCommon/FunctionCalls";
import * as api from "../../../common/manipurCommon/API";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ImageWithBasePath from "../../../../core/data/img/ImageWithBasePath";
import Select from "react-select";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Utils from "../../../common/manipurCommon/Utils";
import Swal from "sweetalert2";

const HPCAssessment = () => {

    const [assessmentList, setAssessmentList] = useState<any[]>([]);
    const [assessmentTypeList, setAssessmentTypeList] = useState<any[]>([]);
    const [gradeList, setGradeList] = useState<any[]>([]);
    const [batchList, setBatchList] = useState<any[]>([]);
    const [scheduleList, setScheduleList] = useState<any[]>([]);
    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [testList, setTestList] = useState<any[]>([]);
    const [skillList, setSkillList] = useState<any[]>([]);
    const [assessGrades, setAssessGrades] = useState<any[]>([]);
    const [geoList, setGeoList] = useState<any[]>([]);
    const [hpcList, setHpcList] = useState<any[]>([]);
    const [geoId, setGeoId] = useState('');
    const [hpcId, setHpcId] = useState('');
    const [athleteId, setAthleteId] = useState("");
    const [scheduleId, setScheduleId] = useState("");
    const [batchId, setBatchId] = useState("");
    const [programId, setProgramId] = useState("");
    const [testId, setTestId] = useState("");
    const [comment, setComment] = useState("");
    const [assessmentDate, setAssessmentDate] = useState("");
    const [assessComment, setAssessComment] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [showSkillList, setShowSkillList] = useState(false);

    // const gradeList = [{ gradeTypeId: 1, gradeType: 'A' }, { gradeTypeId: 2, gradeType: 'B' }, { gradeTypeId: 3, gradeType: 'C' }, { gradeTypeId: 4, gradeType: 'D' }];
    // const asmntTypList = [{ assessmentTypeId: 1, assessmentTypeName: 'Training' }, { assessmentTypeId: 2, assessmentTypeName: 'Final' }];

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    useEffect(() => {
        fetchAssessment();
    }, [])

        async function fetchAssessment() {
            setIsLoading(true);
            const asmntResponse = await func.hpcAssessment(null);
            setAssessmentList(Array.isArray(asmntResponse) ? asmntResponse : []);
            setIsLoading(false);
        }

    const filteredData = assessmentList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const batchNameRender = (rowData) => {
        return <span>{rowData.batchName}</span>
    };

    const skillNameRender = (rowData) => {
        return <span>{rowData.skillName}</span>
    };

    const athleteNameRender = (rowData) => {
        return <span>{rowData.athleteName}</span>
    };

    const progNameRender = (rowData) => {
        return <span>{rowData.programName}</span>
    };

    const gradeRender = (rowData) => {
        return <span>{rowData.gradeType}</span>
    };

    const assessmentTypeRender = (rowData) => {
        return <span>{rowData.assessmentType}</span>
    };

    const dateRender = (rowData) => {
        return <span>{formatDate(rowData.scheduleDate)}</span>
    };

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    async function newAssessment() {
        setIsEdit(false)
        setOpenModal(true)
        const geoResponse = await func.listGeoStates();
        setGeoList(Array.isArray(geoResponse) ? geoResponse : [])
        const batchResponse = await func.hpcBatch(null);
        setBatchList(Array.isArray(batchResponse) ? batchResponse : [])
        const athltResponse = await func.hpcBatchAthelete(null);
        setAthleteList(Array.isArray(athltResponse) ? athltResponse : [])
        const tstResponse = await func.skills(null);
        setTestList(Array.isArray(tstResponse) ? tstResponse : [])
        const asmntTypResponse = await func.assessmentType(null);
        setAssessmentTypeList(Array.isArray(asmntTypResponse) ? asmntTypResponse : []);
        const gradeResponse = await func.gradelist(null);
        setGradeList(Array.isArray(gradeResponse) ? gradeResponse : []);
        setAthleteId("");
        setBatchId("");
        setTestId("");
        setScheduleId("");
        setAssessmentDate("");
        setAssessComment("");
        setAssessGrades([]);
        setShowSkillList(false);
    }

    const handleGradeChange = (e, index) => {
        const value = e.target.value;
        setAssessGrades(prev => {
            const updated = [...prev];
            updated[index] = {
                gradeId: value,
                skillId: skillList[index].skillId  // or whichever field represents skill
            };
            return updated;
        });
    };

    const handleCommentChange = (e, indx) => {
        const updatedComment = { ...comment, [indx]: e.target.value };
        setComment(updatedComment);
    };

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            const formData = new FormData();
            formData.append("athlete", athleteId);
            formData.append("scheduleId", scheduleId);
            formData.append("date", assessmentDate);
            formData.append("batchId", batchId);
            // formData.append("skill", JSON.stringify(skillList.skillName));
            formData.append("skill", JSON.stringify(assessGrades))
            // formData.append("programId", programId);
            formData.append("typeId", testId);

            const createAsmnt = api.HPCAssessment;
            fetch(createAsmnt, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((response) => response.json())
                .then(async (result) => {
                    if (result.error == false) {
                        setIsLoading(false);
                        Swal.fire(result.message)
                        const athltResponse = await func.getHpcAthletesByAssessment(hpcId, batchId, scheduleId, testId);
                        setAthleteList(Array.isArray(athltResponse) ? athltResponse : []);
                        setAthleteId('')
                        setShowSkillList(false)
                        // Swal.fire({
                        //     title: 'Success',
                        //     text: result.message,
                        //     icon: 'success',
                        //     confirmButtonText: 'OK',
                        //     allowOutsideClick: false,
                        //     allowEscapeKey: false
                        // }).then((res) => {
                        //     if (res.isConfirmed) {
                        //         window.location.reload(); // 🔁 Reload only after OK is clicked
                        //     }
                        // });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        })
                    }
                })
        }
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Assessment</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newAssessment() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Assessment">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="athleteName"
                                                header="Athlete Name"
                                                body={athleteNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="batchName"
                                                header="Batch Name"
                                                body={batchNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="skillName"
                                                header="Skill Name"
                                                body={skillNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="programName"
                                                header="Program Name"
                                                body={progNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="gradeType"
                                                header="Grade"
                                                body={gradeRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="assessmentType"
                                                header="Assessment Type"
                                                body={assessmentTypeRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="scheduleDate"
                                                header="Assessment Date"
                                                body={dateRender}
                                                className="table-inset-btn"
                                            ></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {openModal && (
                <Modal
                    show={openModal}
                    size="xl"
                    centered>
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Assessment</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => {setOpenModal(false);fetchAssessment()}}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <form ref={formRef}>
                            <div className="row">
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Geography</label>
                                        <Select
                                            value={geoList.find(state => state.geographyId === geoId) ? {
                                                value: geoId,
                                                label: geoList.find(state => state.geographyId === geoId).geographyName
                                            } : null}
                                            onChange={async (e) => {
                                                setGeoId(e.value);
                                                const hpcResponse = await func.getHpcByGeography(e.value);
                                                setHpcList(Array.isArray(hpcResponse) ? hpcResponse : [])
                                            }}
                                            required
                                            styles={customSelect}
                                            placeholder="Select State"
                                            options={geoList.map(state => ({
                                                value: state.geographyId,
                                                label: state.geographyName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Center</label>
                                        <Select
                                            value={hpcList.find(hpc => hpc.geoHPCId === hpcId) ? {
                                                value: hpcId,
                                                label: hpcList.find(hpc => hpc.geoHPCId === hpcId).geoHPCName
                                            } : null}
                                            onChange={async (e) => {
                                                setHpcId(e.value);
                                                const btchResponse = await func.getBatchByHpc(e.value);
                                                setBatchList(Array.isArray(btchResponse) ? btchResponse : [])
                                            }}
                                            required
                                            styles={customSelect}
                                            placeholder="Select Center"
                                            options={hpcList.map(hpc => ({
                                                value: hpc.geoHPCId,
                                                label: hpc.geoHPCName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Batch Name</label>
                                        <Select
                                            value={batchList.find(btch => btch.batchId === batchId) ? {
                                                value: batchId,
                                                label: batchList.find(btch => btch.batchId === batchId).batchName
                                            } : null}
                                            onChange={async (e) => {
                                                const selected = batchList.find(btch => btch.batchId === e.value);
                                                if (selected) {
                                                    setBatchId(selected.batchId);
                                                    setProgramId(selected.programId);
                                                }
                                                const scdlResponse = await func.getSchedulesByHpcBatch(hpcId, e.value);
                                                setScheduleList(Array.isArray(scdlResponse) ? scdlResponse : [])
                                            }}
                                            required
                                            styles={customSelect}
                                            placeholder="Select Batch"
                                            options={batchList.map(btch => ({
                                                value: btch.batchId,
                                                label: btch.batchName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Assessment Date</label>
                                        <Select
                                            value={(() => {
                                                const selected = scheduleList.find(scdl => scdl.scheduleDate === assessmentDate);
                                                return selected
                                                    ? { value: selected.scheduleId, label: formatDate(selected.scheduleDate) }
                                                    : null;
                                            })()}
                                            onChange={(e) => {
                                                const selected = scheduleList.find(scdl => scdl.scheduleId === e.value);
                                                if (selected) {
                                                    setScheduleId(selected.scheduleId);
                                                    setAssessmentDate(selected.scheduleDate);
                                                }
                                            }}
                                            required
                                            styles={customSelect}
                                            placeholder="Select Date"
                                            options={scheduleList.map(scdl => ({
                                                value: scdl.scheduleId,
                                                label: formatDate(scdl.scheduleDate),
                                            }))}
                                        />

                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Test</label>
                                        <Select
                                            value={assessmentTypeList.find(asmnt => asmnt.assessmentTypeId === testId) ? {
                                                value: testId,
                                                label: assessmentTypeList.find(asmnt => asmnt.assessmentTypeId === testId).assessmentType
                                            } : null}
                                            onChange={async (e) => {
                                                setTestId(e.value);
                                                const response = await func.skills(null);
                                                setSkillList(Array.isArray(response) ? response : []);
                                                const athltResponse = await func.getHpcAthletesByAssessment(hpcId, batchId, scheduleId, e.value);
                                                setAthleteList(Array.isArray(athltResponse) ? athltResponse : []);
                                            }}
                                            required
                                            styles={customSelect}
                                            placeholder="Select Test"
                                            options={assessmentTypeList.map(asmnt => ({
                                                value: asmnt.assessmentTypeId,
                                                label: asmnt.assessmentType
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Athlete</label>
                                        <Select
                                            value={athleteList.find(athlt => athlt.userId === athleteId) ? {
                                                value: athleteId,
                                                label: athleteList.find(athlt => athlt.userId === athleteId).athleteName
                                            } : null}
                                            onChange={async (e) => {
                                                setAthleteId(e.value);
                                                setShowSkillList(true);
                                            }}
                                            required
                                            styles={customSelect}
                                            placeholder="Select Athlete"
                                            options={athleteList.map(athlt => ({
                                                value: athlt.userId,
                                                label: athlt.athleteName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                            </div>
                            {showSkillList && (
                                <>
                                    <div className="table-responsive table-datatble">
                                        <table className="table datatable">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th className="text-uppercase">Skill</th>
                                                    <th className="text-uppercase">Grade</th>
                                                </tr>
                                                {Array.isArray(skillList) && skillList.map((skil, index) => (
                                                    <tr key={index}>
                                                        <td>{skil.skillName}</td>
                                                        <td>
                                                            <select value={assessGrades[index]?.gradeId || ""} onChange={(e) => handleGradeChange(e, index)}>
                                                                <option value="" selected disabled>Select grade</option>
                                                                {Array.isArray(gradeList) && gradeList.map((grd) => (
                                                                    <option key={grd.gradeTypeId} value={grd.gradeTypeId}>{grd.gradeType}</option>
                                                                ))}
                                                            </select>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </thead>
                                        </table>
                                    </div>
                                </>
                            )}
                            <ModalFooter>
                                <Button
                                    className="btn-primary text-uppercase"
                                    variant="success"
                                    type="submit"
                                    onClick={handleSubmit}
                                >
                                    <b><i className="fas fa-save" />Save</b>
                                </Button>
                            </ModalFooter>
                        </form>
                    </ModalBody>
                </Modal>
            )}
        </>
    );
};

export default HPCAssessment;